import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { ResetPasswordMutationRequest, ResetPasswordMutationResponse, ResetPassword400 } from "../types/ResetPassword";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ResetPasswordClient = typeof client<ResetPasswordMutationResponse, ResetPassword400, ResetPasswordMutationRequest>;
type ResetPassword = {
    data: ResetPasswordMutationResponse;
    error: ResetPassword400;
    request: ResetPasswordMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: ResetPasswordMutationResponse;
    client: {
        parameters: Partial<Parameters<ResetPasswordClient>[0]>;
        return: Awaited<ReturnType<ResetPasswordClient>>;
    };
};
/**
 * @summary Reset password
 * @link /api/forgot-password/reset-password
 */
export function useResetPassword(options: {
    mutation?: UseMutationOptions<ResetPassword["response"], ResetPassword["error"], ResetPassword["request"]>;
    client?: ResetPassword["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<ResetPassword["data"], ResetPassword["error"], ResetPassword["request"]>({
                method: "post",
                url: `/api/forgot-password/reset-password`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}